
export enum RequestListFilters {
	Open = 'Open',
	Edit = 'Edit',
	Review = 'Review',
	Process = 'Process',
	Reply = 'Reply',
	Unverified = 'Unverified',
	Closed = 'Closed',
};